// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Td6K_IS7YPa4oKR1Svue{background-color:#fff;padding:10px;border-radius:10px;border:1px solid #d6d5d5}`, "",{"version":3,"sources":["webpack://./src/pages/Assets/pages/components/RevenueBreakdown/components/InfoBox/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,qBAAA,CACA,YAAA,CACA,kBAAA,CACA,wBAAA","sourcesContent":[".infoContainer\n  background-color: #fff\n  padding: 10px\n  border-radius: 10px\n  border: 1px solid #d6d5d5"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoContainer": `Td6K_IS7YPa4oKR1Svue`
};
export default ___CSS_LOADER_EXPORT___;
